import { canLoadLocalDraft, loadLocalDraft, saveLocalDraft } from '@ff-os/pdp-shared-redux/apis/localDrafts';
import { loadProject } from '@ff-os/pdp-shared-redux/apis/projects/loadProject';
import { bindRefreshAuthorization } from '@ff-os/pdp-shared-redux/authorizationBindings';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { actions as authActions } from '@ff-os/pdp-shared-redux/slices/authSlice';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

export const tryLoadProject = (store: PdpStore, options?: IDT.OpenOptions) => {
    if (options) {
        openProject(store, options);
    } else {
        tryOpenLocalDraft(store);
    }
};

const openProject = (store: PdpStore, openOptions: IDT.OpenOptions) => {
    bindRefreshAuthorization(openOptions.refresh);
    store.dispatch(authActions.updateFromJwt(openOptions.authorize));
    store.dispatch(loadProject({ onSuccess: window.__idt_show }));
};

const tryOpenLocalDraft = (store: PdpStore) => {

    if (canLoadLocalDraft(store.getState())) {
        store.dispatch(loadLocalDraft());
    }

    saveLocalDraftOnDesignChange(store);
};

const saveLocalDraftOnDesignChange = (store: PdpStore) => {

    const state = store.getState();
    const plugin = scenePlugins.require(state.scene.pluginId);

    plugin.addDesignChangeListener(store, () => {
        store.dispatch(saveLocalDraft({ throttle: true }));
    });
};